import { render, staticRenderFns } from "./ReportG.vue?vue&type=template&id=219febda&scoped=true&"
import script from "./ReportG.vue?vue&type=script&lang=js&"
export * from "./ReportG.vue?vue&type=script&lang=js&"
import style0 from "./ReportG.vue?vue&type=style&index=0&id=219febda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219febda",
  null
  
)

export default component.exports